import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=a4c4e5dc"
import script from "./customerInfo.vue?vue&type=script&lang=js"
export * from "./customerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4c4e5dc')) {
      api.createRecord('a4c4e5dc', component.options)
    } else {
      api.reload('a4c4e5dc', component.options)
    }
    module.hot.accept("./customerInfo.vue?vue&type=template&id=a4c4e5dc", function () {
      api.rerender('a4c4e5dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/customerManage/customerInfo.vue"
export default component.exports